import { apiFetch, API_BASE_URL, resolvePostLoginHomePath } from "../api";
import { persistLoginSession } from "./loginEligibility";
import { syncViewerAccessFlags } from "./viewerAccess";

/** After loginUser() succeeds: store session, load photo/gender, resolve redirect path. */
export async function completeLoginAfterApi(data) {
  persistLoginSession(data);

  const profileId = data.data?.ProfileID ?? data.data?.profileID;
  const row = data.data;
  const pid =
    profileId ??
    (Array.isArray(row) ? row[0]?.ProfileID ?? row[0]?.profileID : null);
  if (pid) {
    apiFetch(
      `${API_BASE_URL}?api=get_profile&ProfileID=${encodeURIComponent(pid)}`,
    )
      .then((profileRes) => {
        const row = profileRes?.data?.[0];
        if (row?.ProfilePhoto) {
          localStorage.setItem("profilePhoto", row.ProfilePhoto);
        }
        if (row?.GenderID != null && row.GenderID !== "") {
          localStorage.setItem("viewerGenderID", String(row.GenderID));
        }
        syncViewerAccessFlags(row);
      })
      .catch(() => {});
  }

  try {
    return await resolvePostLoginHomePath(data.data?.UserID);
  } catch {
    return "/";
  }
}
